import Swal from 'sweetalert2';

export function gigSwal(theme, options) {
  return Swal.fire({
    background: theme.surface,
    color: theme.text,
    confirmButtonColor: theme.primary,
    cancelButtonColor: '#6c757d',
    didOpen: (popup) => {
      popup.style.border = `1px solid ${theme.border}`;
      popup.style.boxShadow = theme.isDark
        ? '0 20px 60px rgba(0,0,0,0.8)'
        : '0 20px 60px rgba(0,0,0,0.15)';
    },
    ...options,
  });
}
